<template>
    <div class="content">
        <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
            <supervisor-account>
            </supervisor-account> 
            </div>
        </div>  
        </div>
    </div>
    </template>
    <script>
    /* eslint-disable */
    import supervisorAccount from './todo-supervisor-account'
    export default {
        components: {
            supervisorAccount
        }
    }
    </script>
    <style lang="scss">
    </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-users/base-supervisor-account.vue